export default {
    homePara:
      "La localisation linguistique est le processus d'adaptation de la traduction d'un produit à un pays ou une région spécifique. C'est la deuxième phase d'un processus plus large de traduction de produits et d'adaptation culturelle pour tenir compte des différences entre les marchés distincts, un processus connu sous le nom d'internationalisation et de localisation",
    aboutPara:
      "Ce didacticiel vise à simplifier la localisation. Bien qu'il existe de nombreux tutoriels disponibles sur Internet. Mais celui-ci vous apprendra le concept de manière simple. Vous pouvez directement utiliser ce code pour votre logiciel. J'ai utilisé des crochets «Rreact» qui sont maintenant la norme de l'industrie du logiciel. Vous pouvez suivre mon blog pour obtenir plus d'articles liés à l'interface utilisateur, ce qui fera de vous un meilleur développeur «UI». {0}",
    changeLanguage: "Changez votre langue",
    name: "Nom",
    age: "Âge",
    address: "Adresse",
    contactNo: "Numéro de contact",
    save: "Sauver",
    formPara: "Veuillez entrer vos informations personnelles ici.",
    dynamicValue: "Dynamic Value- {randomNumber} {date}"
  };
  